<template>
  <td class="font-weight-bold text-center custom-border">
    <span class="my-2 text-xs" style="word-break: break-all; white-space: pre-line;">{{ dateTime }}</span>
  </td>
  <td class="text-center powder-name-cell">{{ powderName ? powderName : '-' }}</td>
  <td
    class="text-xs font-weight-bold text-center custom-border"
    style="cursor: pointer"
    @click="handleClickBenchmark('/applications/blueprint/benchmarkandtarget/' + lineId + '/' + visitId)"
  >
    <div class="d-flex align-items-center justify-content-center">
      <soft-button
        :color="colorizeBenchmark() "
        variant="outline"
        class="btn-icon-only btn-rounded mb-0 btn-sm d-flex align-items-center justify-content-center"
      >
        <i
          :class="setIcon(benchmarkChecked)"
          aria-hidden="true"
        ></i>
      </soft-button>
    </div>
  </td>
  <td
    class="text-xs font-weight-bold text-center custom-border"
    style="cursor: pointer"
    @click="handleClickHealth('/applications/blueprint/healthcheck/' + lineId + '/' + visitId)"
  >
    <div class="d-flex justify-content-center">
      <soft-button
        :color="colorizeHealthCheck()"
        variant="outline"
        class="btn-icon-only btn-rounded mb-0 btn-sm d-flex align-items-center justify-content-center"
      >
        <i
          :class="setIcon(healthChecked)"
          aria-hidden="true"
        ></i>
      </soft-button>
    </div>
  </td>
  <td
    class="text-xs font-weight-bold text-center custom-border"
    style="cursor: pointer"
    @click="handleClickGunsEqualization('/applications/blueprint/gunsequalization/' + lineId + '/' + visitId)"
  >
    <div class="d-flex align-items-center justify-content-center">
      <soft-button
        :color="colorizeGunsEqualization()"
        variant="outline"
        class="btn-icon-only btn-rounded mb-0 btn-sm d-flex align-items-center justify-content-center"
      >
        <i
          :class="setIcon(gunsEqualizationChecked)"
          aria-hidden="true"
        ></i>
      </soft-button>
    </div>
  </td>
  <td
    class="text-xs font-weight-bold text-center custom-border"
    style="cursor: pointer"
    @click="handleClickSprayPattern(`/applications/blueprint/powdermodels/${lineId}/${visitId}`)"
  >
    <div class="d-flex align-items-center justify-content-center">
      <soft-button
        :color="colorizeSprayPattern()"
        variant="outline"
        class="btn-icon-only btn-rounded mb-0 btn-sm d-flex align-items-center justify-content-center"
      >
        <i
          :class="setIconSprayPattern()"
          aria-hidden="true"
        ></i>
      </soft-button>
    </div>
  </td>
  <td
    class="text-xs font-weight-bold text-center custom-border"
    style="cursor: pointer"
    @click="handleClickReciprocator('/applications/blueprint/reciprocatoroptimizationslibrary/' + lineId + '/' + visitId)"
  >
    <div class="d-flex align-items-center justify-content-center">
      <soft-button
        :color="colorizeRecirpocator()"
        variant="outline"
        class="btn-icon-only btn-rounded mb-0 btn-sm d-flex align-items-center justify-content-center"
      >
        <i
          :class="setIconReciprocator()"
          aria-hidden="true"
        ></i>
      </soft-button>
    </div>
  </td>
  <td
    class="text-xs font-weight-bold text-center"
    style="cursor: pointer"
    @click="handleClickThicknessAdjust('/applications/blueprint/thicknessadjustment/' + lineId + '/' + visitId)"
  >
    <div class="d-flex align-items-center justify-content-center">
      <soft-button
        :color="colorizeThicknessAdjustment()"
        variant="outline"
        class="btn-icon-only btn-rounded mb-0 btn-sm d-flex align-items-center justify-content-center"
      >
        <i
          :class="setIconThicknessAdjustment()"
          aria-hidden="true"
        ></i>
      </soft-button>
    </div>
  </td>
  <td
    class="text-xs font-weight-bold text-center"
    style="cursor: pointer"
    @click="$emit('delete-visit', visitId, dateTime)"
  >
    <a class="btn btn-link text-danger text-gradient px-3 mb-0 my-auto">
      <i
        class="far fa-trash-alt me-2"
        aria-hidden="true"
      >
      </i>
    </a>
  </td>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";

export default {
  name: "VisitRow",
  components: {
    SoftButton,
  },
  props: {
    dateTime: {
      type: String,
      default: "",
    },
    powderName: {
      type: String,
      default: null,
    },
    benchmarkChecked: {
      type: String,
      default: "Pending",
    },
    healthChecked: {
      type: String,
      default: "Pending",
    },
    gunsEqualizationChecked: {
      type: String,
      default: "Pending",
    },
    sprayPatternChecked: {
      type: String,
      default: "Pending",
    },
    reciprocatorChecked: {
      type: String,
      default: "Pending",
    },
    thicknessAdjustmentChecked: {
      type: String,
      default: "Pending",
    },
    finalizedAtStage: {
      type: String,
      default: "not_finalized",
    },
    lineId: {
      type: String,
      default: "",
    },
    visitId: {
      type: Number,
      default: null,
    },
  },
  emits: [
    "delete-visit",
  ],
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;
    return {
      blockedIcon: "fas fa-ban",
      // blockedIcon: "fas fa-lock",
    };
  },
  watch: {
    "$store.state.user_data.language"() {
      this.$i18n.locale = this.$store.state.user_data.language;
    },
  },
  computed: {
    blockedReciprocator() {
      return this.finalizedAtStage == "finalized_at_spraypattern";
    },
    blockedThicknessAdjustment() {
      return (
        this.finalizedAtStage == "finalized_at_spraypattern" ||
        this.finalizedAtStage == "finalized_at_reciprocator"
      );
    },
  },
  methods: {
    handleClickBenchmark() {
      if (this.$router.currentRoute.name == "BenchmarkAndTarget") {
        return;
      }

      this.$router.push({ 
        name: "BenchmarkAndTarget",
        params: {
          lineId: this.lineId,
          visitId: this.visitId,
        },
      });
    },
    handleClickHealth() {
      if (this.$router.currentRoute.name == "HealthCheck") {
        return;
      }

      this.$router.push({ 
        name: "HealthCheck",
        params: {
          lineId: this.lineId,
          visitId: this.visitId,
        },
      });
    },
    handleClickGunsEqualization() {
      if (this.$router.currentRoute.name == "GunsEqualization") {
        return;
      }

      this.$router.push({ 
        name: "GunsEqualization",
        params: {
          lineId: this.lineId,
          visitId: this.visitId,
        },
      });
    },
    handleClickSprayPattern() {
      if (this.$router.currentRoute.name == "SprayPatternStage") {
        return;
      }

      this.$router.push({ 
        name: "SprayPatternStage",
        params: {
          lineId: this.lineId,
          visitId: this.visitId,
        },
      });
    },
    handleClickReciprocator() {
      if (
        this.blockedReciprocator ||
        this.$router.currentRoute.name == "ReciprocatorOptimizationsLibrary"
      ) {
        return;
      }

      this.$router.push({ 
        name: "ReciprocatorOptimizationsLibrary",
        params: {
          lineId: this.lineId,
          visitId: this.visitId,
        },
      });
    },
    handleClickThicknessAdjust() {
      if (
        this.blockedThicknessAdjustment ||
        this.$router.currentRoute.name == "ThicknessAdjustment"
      ) {
        return;
      }

      this.$router.push({ 
        name: "ThicknessAdjustment",
        params: {
          lineId: this.lineId,
          visitId: this.visitId,
        },
      });
    },
    colorizeBenchmark() {
      return this.colorizeProgress(this.benchmarkChecked);
    },
    colorizeHealthCheck() {
      return this.colorizeProgress(this.healthChecked);
    },
    colorizeGunsEqualization() {
      return this.colorizeProgress(this.gunsEqualizationChecked);
    },
    colorizeSprayPattern() {
      return this.colorizeProgress(this.sprayPatternChecked);
    },
    colorizeRecirpocator() {
      if (this.blockedReciprocator) {
        return "gray";
      }
      return this.colorizeProgress(this.reciprocatorChecked);
    },
    colorizeThicknessAdjustment() {
      if (this.blockedThicknessAdjustment) {
        return "gray";
      }
      return this.colorizeProgress(this.thicknessAdjustmentChecked);
    },
    colorizeProgress(value) {
      if (value == "Completed") {
        return "success";
      } else if (value == "In Progress") {
        return "warning";
      } else {
        return "danger";
      }
    },
    setIconSprayPattern() {
      return this.setIcon(this.sprayPatternChecked);
    },
    setIconReciprocator() {
      if (this.blockedReciprocator) {
        return this.blockedIcon;
      }
      return this.setIcon(this.reciprocatorChecked);
    },
    setIconThicknessAdjustment() {
      if (this.blockedThicknessAdjustment) {
        return this.blockedIcon;
      }
      return this.setIcon(this.thicknessAdjustmentChecked);
    },
    setIcon(value) {
      if (value == "Completed") {
        return "fas fa-check";
      } else if (value == "In Progress") {
        return "fas fa-spinner";
      } else {
        return "fas fa-times";
      }
    },
  },
};
</script>

<style scoped>
td {
  text-align: center;
  vertical-align: middle;
}
.powder-name-cell {
  max-width: 220px;
  min-width: 160px;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-line;
}
.custom-border {
  position: relative;
}
.custom-border::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  height: 50%; /* Adjust the height to make the border shorter */
  border-right: 1px solid rgba(128, 128, 128, 0.3); /* Light gray with low opacity */
  transform: translateY(-50%);
}
</style>
